import React from "react";
export function PromoBar() {
  return <div className="sticky top-0 z-50 border-b border-line bg-ink/95 backdrop-blur" data-id="element-167" data-mp="2sdgek435bzae">
      <div className="mx-auto flex max-w-5xl items-center justify-center gap-2 px-4 py-2 text-xs sm:px-5 sm:py-2.5 sm:text-sm" data-id="element-168" data-mp="8aqgubtxvf2c">
        <p className="truncate text-cream" data-id="element-169" data-mp="3gm8pp8xt0zo">
          <span className="mr-1.5 font-bold tracking-wider text-gold" data-id="element-170" data-mp="3uprvdg8p5sm0">LE PACK COMPLET</span>
          <span className="hidden sm:inline" data-id="element-171" data-mp="3qny23t0tzqvv">2 livres complémentaires + 5 bonus offerts — 27 $ US, paiement unique</span>
          <span className="sm:hidden" data-id="element-172" data-mp="3lninky4tcdcb">2 livres + 5 bonus · 27 $ US</span>
        </p>
      </div>
    </div>;
}